import api from "./Api";
import { BASE_URL } from "./Context/config";

export interface PutContact {
  Id: number;
  Category: string;
  ContactInfo: string;
  Title?: string;
  isPublic: boolean;
}

export interface PostContact {
  UserId: number;
  ContactInfo: string;
  Category: string;
  Title?: string;
  isPublic: boolean;
}

export const EditContact = async (newContact: PutContact) => {
  const data = {
    Id: newContact.Id,
    Category: newContact.Category,
    ContactInfo: newContact.ContactInfo,
    Title: newContact.Title,
    isPublic: newContact.isPublic,
  };

  if (newContact.isPublic === true) data.isPublic = true;
  else data.isPublic = false;

  try {
    const response = await api.put(`${BASE_URL}/Contact/EditContact`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("EditContact Error:", error);

    if (error.response) {
      // Server responded with error status
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.message ||
        `Server error: ${error.response.status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      // Network error
      throw new Error("Network error: Unable to connect to server");
    } else {
      // Other error
      throw new Error(error.message || "Unknown error occurred");
    }
  }
};

export const DeleteContact = async (Id: number) => {
  try {
    const response = await api.delete(
      `${BASE_URL}/Contact/DeleteContact/${Id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateContact = async (newContact: PostContact) => {
  const data = {
    UserId: newContact.UserId,
    Category: newContact.Category || "CvFile",
    ContactInfo: newContact.ContactInfo,
    Title: newContact.Title,
    isPublic: newContact.isPublic,
  };

  if (newContact.isPublic === true) data.isPublic = true;
  else data.isPublic = false;

  try {
    const response = await api.post(`${BASE_URL}/Contact/CreateContact`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error creating contact:", error);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);

    // Handle structured error responses from backend
    if (error.response && error.response.data) {
      const errorData = error.response.data;

      // Check for limit reached error
      if (errorData.error === "LIMIT_REACHED") {
        throw new Error(
          errorData.message || "Contact limit reached for your plan."
        );
      }

      // Handle other error formats
      if (typeof errorData === "string") {
        throw new Error(errorData);
      }
      if (errorData.error) {
        throw new Error(errorData.error);
      }
      if (errorData.message) {
        throw new Error(errorData.message);
      }
    }

    // Provide user-friendly error messages based on status codes
    if (error.response) {
      switch (error.response.status) {
        case 400:
          throw new Error(
            "Invalid contact data. Please check your information and try again."
          );
        case 401:
          throw new Error("Authentication failed. Please log in again.");
        case 403:
          throw new Error(
            "You've reached your plan limit. Please upgrade to add more contacts."
          );
        case 500:
          throw new Error(
            "Server error while creating contact. Please try again later."
          );
        default:
          throw new Error("Failed to create contact. Please try again.");
      }
    }

    throw error;
  }
};
